// ============================================
// i18n — Русский
// ============================================

export const ru = {
  // Общие
  app_name: 'Samsa',
  next: 'Далее →',
  back: '← Назад',
  cancel: 'Отмена',
  save: 'Сохранить',
  delete: 'Удалить',
  add: 'Добавить',
  edit: 'Редактировать',
  loading: 'Загрузка...',
  error: 'Ошибка',
  success: 'Готово!',

  // Навигация
  step: 'Шаг {current} из {total}',

  // Шаг 1 — Основная информация
  step1_title: 'Основная информация',
  business_name: 'Название бизнеса',
  business_name_placeholder: 'Мой салон',
  business_description: 'Описание',
  business_description_placeholder: 'Лучший салон в Астане',
  phone: 'Телефон',
  phone_placeholder: '+7 777 123 45 67',
  whatsapp: 'WhatsApp',
  whatsapp_placeholder: '77771234567',
  instagram: 'Instagram',
  instagram_placeholder: 'my_salon',
  address: 'Адрес',
  address_placeholder: 'Астана, ул. Пушкина 10',
  work_hours: 'Часы работы',
  work_hours_placeholder: 'Пн-Сб 9:00-20:00',

  // Шаг 2 — Страна и город
  step2_title: 'Страна и город',
  country: 'Страна',
  city: 'Город',
  country_kz: 'Казахстан',
  country_ru: 'Россия',
  country_uz: 'Узбекистан',
  country_kg: 'Кыргызстан',
  city_astana: 'Астана',
  city_almaty: 'Алматы',
  city_shymkent: 'Шымкент',
  city_karaganda: 'Караганда',
  city_aktau: 'Актау',
  city_atyrau: 'Атырау',
  city_pavlodar: 'Павлодар',
  city_uryzhar: 'Усть-Каменогорск',
  city_other: 'Другой',

  // Шаг 3 — Товары/Услуги
  step3_title: 'Товары и услуги',
  add_item: '+ Добавить товар/услугу',
  item_name: 'Название',
  item_name_placeholder: 'Стрижка мужская',
  item_price: 'Цена',
  item_price_placeholder: '3 000 ₸',
  item_description: 'Описание (необязательно)',

  // Шаг 4 — Цвет и стиль
  step4_title: 'Цвет и стиль',
  color_scheme: 'Цветовая схема',
  template: 'Шаблон',
  template_minimal: 'Минимальный',
  template_bright: 'Яркий',
  custom_color: 'Свой цвет',

  // Шаг 5 — Предпросмотр и оплата
  step5_title: 'Предпросмотр',
  preview: 'Предпросмотр лендинга',
  price: 'Стоимость',
  price_tenge: '1 990 ₸',
  pay_button: '⭐ Оплатить и создать',
  promocode_label: 'Есть промокод?',
  promocode_placeholder: 'Введите промокод',
  promocode_check: 'Проверить',
  promocode_valid: '✅ Промокод активен! Осталось: {remaining}',
  promocode_invalid: '❌ {reason}',
  use_promocode: 'Использовать промокод',

  // Мои лендинги
  my_landings: 'Мои лендинги',
  no_landings: 'У вас пока нет лендингов',
  create_first: 'Создать первый',
  status_active: 'Активен',
  status_draft: 'Черновик',
  status_disabled: 'Отключён',

  // Сообщения
  draft_saved: 'Черновик сохранён',
  payment_success: 'Оплата прошла! Лендинг создаётся...',
  payment_failed: 'Ошибка оплаты. Попробуйте снова.',
  limit_reached: 'Дневной лимит исчерпан. Попробуйте завтра.',

  // Цвета
  color_blue: 'Синий',
  color_green: 'Зелёный',
  color_dark: 'Тёмный',
  color_light: 'Светлый',
  color_red: 'Красный',
  color_purple: 'Фиолетовый',
};

export type Translations = typeof ru;
